"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.to-string.js");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Global components
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This component renders an SVB Switch
 */

/**
 * SVBSwitch
 * @param preset: strings like default with blue outline if alternative with grey outline
 * see ../readme.MD for sample body
 * @param checked: boolean value true or false
 * @param onPress: function to handle switch onchange handler 
 * @returns SVB Switch component
 */
const SVBSwitch = props => {
  const preset = (props === null || props === void 0 ? void 0 : props.preset) || "default";
  const isChecked = (props === null || props === void 0 ? void 0 : props.checked) || false;
  const onPress = props === null || props === void 0 ? void 0 : props.onPress;
  const idString = (Math.random() + 1).toString(36).substring(7);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "toggle-container"
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: "cb_id".concat(idString),
    onChange: () => onPress(),
    className: preset === "default" ? "toggle-round" : "toggle-round alternative",
    type: "checkbox",
    checked: isChecked
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "cb_id".concat(idString)
  }));
};
var _default = SVBSwitch;
exports.default = _default;